import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import {
  Box,
  Button,
  Container,
  CardContent,
  Divider,
  Card,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Paper,
  Collapse,
  TextField,
  Tooltip,
} from "@mui/material";
import PerfectScrollbar from "react-perfect-scrollbar";
import Typography from "@mui/material/Typography";
import Popover from "@mui/material/Popover";
import SearchField from "react-search-field";
import { Tab, Tabs } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { CopyToClipboard } from "react-copy-to-clipboard";
import IconButton from "@mui/material/IconButton";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import StartLab from "./Actions/Startlab";
import StopLab from "./Actions/Stoplab";
import Refresh from "./Actions/Reload";
import NotToDo from "./Actions/NotToDo";
import WarningAlert from "./Alert/WarningAlert";
import IndividualStartLab from "./Actions/IndividualStartlab";
import IndividualStopLab from "./Actions/IndividualStoplab";
import ReportEX from "../Custom/ReportExport";
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import ActiveLog from "src/pages/LabManager/ActiveLog";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import StopTwoToneIcon from "@mui/icons-material/StopTwoTone";
import PlayArrowTwoToneIcon from "@mui/icons-material/PlayArrowTwoTone";
import DeleteIcon from "@mui/icons-material/Delete";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Log from "./Logs/CustomLog"
import TrainerGuacConnect from "./TrainerGuacConnect";
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import RefreshIcon from '@mui/icons-material/Refresh';
// import OverallLabReport from "../../LabManager/OverallLabReport";

const dialogWidth = '1100px';
const dialogHeight = '97vh';

const CustomDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    width: dialogWidth,
    height: dialogHeight, // Use full viewport height
    maxWidth: 'none',
    margin: 0,
    padding: theme.spacing(2),
    overflow: 'hidden', // Ensure no overflow on the dialog itself
    display: 'flex', // Flexbox to manage layout
    flexDirection: 'column',
  },
  '& .MuiDialogContent-root': {
    padding: 0,
    flexGrow: 1, // Take remaining space
    overflow: 'auto', // Enable scrolling on the content area
  },
  '& .MuiDialogActions-root': {
    justifyContent: 'flex-end',
  },
}));

const ensureAbsoluteUrl = (url) => {
  if (!url) return '#'; // Fallback in case URL is null or undefined
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return `http://${url}`;
  }
  return url;
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#b5b6b7",
    display: "flex",
    height: 280,
  },
  tabs: {
    borderRight: `1px solid`,
    overflow: `visible`,
  },
  title: {
    fontSize: 14,
  },
}));

const Detail = () => {
  const classes = useStyles();

  const [expandedRow, setExpandedRow] = useState(null);
  const [validerroropen, setValidErrorOpen] = useState(false);

  const handleExpandRow = (rowName) => {
    if (rowName === expandedRow) {
      setExpandedRow(null);
    } else {
      setExpandedRow(rowName);
    }
  };

  const [value, setValue] = React.useState("");

  function DateTime1(startDate) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const startDate1 = new Date(startDate).toLocaleString("en-GB", {
      timeZone: `${timezone}`,
    });
    const startDate2 = startDate1.split(",");
    const startDatef = startDate2[0].replace("/", "-");
    const startDate3 = startDatef.replace("/", "-");

    return startDate3;
  }

  function DateTime21(endDate) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const endDate1 = new Date(endDate).toLocaleString("en-GB", {
      timeZone: `${timezone}`,
    });
    const endDate2 = endDate1.split(",");
    const endDatef = endDate2[0].replace("/", "-");
    const endDate3 = endDatef.replace("/", "-");
    return endDate3;
  }

  function DateTime2(endDate, endTime) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const endDate1 = new Date(endDate + "T" + endTime + ":00.000Z").toLocaleString("en-GB", { timeZone: `${timezone}` });
    const endDate2 = endDate1.split(",");
    const endDatef = endDate2[0].replace("/", "-");
    const endDate3 = endDatef.replace("/", "-");
    return endDate3;
  }

  function DateTime3(startDate, startTime) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const startTime1 = new Date(
      startDate + "T" + startTime + ":00.000Z"
    ).toLocaleString("en-GB", { timeZone: `${timezone}` });
    const startTime2 = startTime1.split(",");
    const startTime3 = startTime2[1].substring(0, 6);
    return startTime3;
  }

  function DateTime4(endDate, endTime) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const endTime1 = new Date(
      endDate + "T" + endTime + ":00.000Z"
    ).toLocaleString("en-GB", { timeZone: `${timezone}` });
    const endTime2 = endTime1.split(",");
    const endTime3 = endTime2[1].substring(0, 6);
    return endTime3;
  }

  const handleChange = (event) => {
    setValue(parseInt(event.target.value));
  };

  const [showInstancePassword, setShowInstancePassword] = useState(false);
  const [showAppPasswords, setShowAppPasswords] = useState(false);

  const handleInstancePasswordIconClick = () => {
    setShowInstancePassword(!showInstancePassword);
  };

  const handleAppPasswordIconClick = () => {
    setShowAppPasswords(!showAppPasswords);
  };


  const [instancelist, setinstancelist] = useState([]);
  const [depends_On, setDependsOn] = useState('');
  const [manage_Labs, setManageLabs] = useState('');
  const [popupstatus, setPopupStatus] = useState('');
  useEffect(() => {
    const InstanceID = localStorage.getItem("InstanceID");
    fetch(`${process.env.REACT_APP_API_URL}/api/labcustomize/${InstanceID}/trainer`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setinstancelist(data);
          const depends_on = data.map(item => item.depends_on)
          setDependsOn(depends_on[0]);
          const manage_labs = data.map(item => item.manage_labs)
          setManageLabs(manage_labs[0]);
          setPopupStatus(data[0]?.popup_status || "");
          if (data[0]?.popup_status === "no" || data[0]?.popup_status === "") {
            setValidErrorOpen(true);
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  function timeDiff(endDate, endTime, startDate, startTime, dependsOn, manageLabs) {
    const nowTime = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const endTime1 = new Date(endDate + "T" + endTime + ":00.000Z").toLocaleString("en-GB", { timeZone: `${timezone}` });
    const endTime2 = endTime1.split(",");
    const endTime3 = endTime2[1].substring(0, 6);

    const startTime1 = new Date(startDate + "T" + startTime + ":00.000Z").toLocaleString("en-GB", { timeZone: `${timezone}` });
    const startTime2 = startTime1.split(",");
    const startTime3 = startTime2[1].substring(0, 6);

    const endTimeMoment = moment(endTime3, 'HH:mm');
    const currentTimeMoment = moment(nowTime, 'HH:mm');

    const diffInMinutes = endTimeMoment.diff(currentTimeMoment, 'minutes');
    let disable = true;

    const labEndDate = moment(endDate).format('DD-MM-YYYY');
    const currentDate = new Date().toISOString().substring(0, 10);

    if (dependsOn === "immediate" || dependsOn === "always") {
      if (DateTime21(currentDate) === labEndDate) {
        if (diffInMinutes > 0 && diffInMinutes <= `${process.env.REACT_APP_DIFFENDTIME}`) {
          disable = true;
        }
        else if (diffInMinutes <= 0) {
          disable = true;
        }
        else {
          disable = false;
        }
      }
      else {
        if (new Date(currentDate) <= new Date(endDate)) {
          disable = false;
        }
        else {
          disable = true;
        }
      }
    }
    else if (dependsOn === "during_training") {
      if (diffInMinutes > 0 && diffInMinutes <= `${process.env.REACT_APP_DIFFENDTIME}`) {
        disable = true;
        return disable;
      } else if (currentTimeMoment.isSameOrAfter(moment(startTime3, 'HH:mm')) && currentTimeMoment.isSameOrBefore(moment(endTime3, 'HH:mm'))) {
        disable = false;
        // return disable;       
      } else if (dependsOn === "during_training" && manageLabs === "yes") {
        disable = false;
        return disable;
      } else if (dependsOn === "during_training" && manageLabs === "no" && currentTimeMoment.isAfter(moment(endTime3, 'HH:mm'))) {
        disable = true;
      }
    }

    return disable;
  }

  const [pccreportdataset, setPccreportdataset] = useState([]);

  useEffect(() => {
    const InstanceID = localStorage.getItem("InstanceID");
    fetch(`${process.env.REACT_APP_API_URL}/api/pcclabreport/${InstanceID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        setPccreportdataset(data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const [opendelete, setOpendelete] = React.useState(false);

  const handleClickOpenDelete = () => {
    setOpendelete(true);
  };

  const handleCloseDelete = () => {
    setOpendelete(false);
  };

  const Delete = () => {
    return function () {
      window.location.href = "/app/runninglabs";
      const InstanceID = localStorage.getItem("InstanceID");
      fetch(
        `${process.env.REACT_APP_API_URL}/api/manageInstance/${InstanceID}/`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          handleCloseDelete();
        })
        .catch((error) => {
          handleCloseDelete();
        });
      handleCloseDelete();
    };
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open1 = Boolean(anchorEl);

  const id = open1 ? "simple-popover" : undefined;

  const [copied, setCopied] = React.useState(false);

  useEffect(() => {
    setExpandedRow("");
  }, [value])

  const [openDialog, setOpenDialog] = useState(false);
  const [guacData, setGuacData] = useState([]);
  const [refreshConnection, setRefreshConnection] = useState(false);

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleRefreshConnection = () => {
    setRefreshConnection(true);
  };

  return (
    <>
      <WarningAlert
        validerroropen={validerroropen}
        setvaliderroropen={setValidErrorOpen}
        alertLabType={"custom"}
      />
      {instancelist.map((instancelist) => (
        <React.Fragment key={instancelist.id}>
          <Helmet>
            <title>LabAsService</title>
          </Helmet>
          <Box
            sx={{
              backgroundColor: "background.default",
              minHeight: "100%",
              py: 3,
            }}
          >
            <div
              style={{ alignItems: "center", display: "flex", width: "600px" }}
            >
              <CustomDialog
                open={openDialog}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle style={{ marginTop: "-30px", display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} id="alert-dialog-title">
                  Guacamole Display - Machine Name : {guacData.name}
                  <div>
                    <Tooltip title="Refresh Connection" arrow>
                      <IconButton
                        aria-label="refresh"
                        onClick={handleRefreshConnection}
                        style={{ color: 'blue' }}
                      >
                        <RefreshIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Close" arrow>
                      <IconButton
                        aria-label="close"
                        onClick={handleCloseDialog}
                        style={{ color: 'red' }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                </DialogTitle>
                <DialogContent style={{ marginTop: "-20px" }}>
                  <TrainerGuacConnect
                    details={guacData}
                    width={dialogWidth}
                    height={dialogHeight}
                    refreshConnection={refreshConnection}
                    disableCopyPaste={instancelist.disable_copypaste_guac}
                    onRefreshComplete={() => setRefreshConnection(false)}
                  />
                </DialogContent>
              </CustomDialog>
              <Dialog
                open={opendelete}
                onClose={handleCloseDelete}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  Are you sure you want to delete the Lab{" "}
                  <strong style={{ color: "#EF5350" }}>
                    {instancelist.name}
                  </strong>{" "}
                  ?
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description"></DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Tooltip title="Cancel" arrow>
                    <Button
                      onClick={handleCloseDelete}
                      color="primary"
                      sx={{
                        borderRadius: '50px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                        px: 3,
                      }}
                    >
                      Disagree
                    </Button>
                  </Tooltip>
                  <Tooltip title="Confirm Delete" arrow>
                    <Button
                      onClick={Delete(instancelist.id)}
                      color="primary"
                      autoFocus
                      sx={{
                        borderRadius: '50px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                        px: 3,
                      }}
                    >
                      Agree
                    </Button>
                  </Tooltip>
                </DialogActions>
              </Dialog>
            </div>

            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 0, pb: 0 }}>
              <NotToDo/>
              <Refresh />
              {/* <OverallLabReport
                name={instancelist.name}
                index_name={instancelist.name}
                analytics_panel_id={instancelist.overall_activity_panel_id}
              /> */}
              {instancelist.status === "Stopped" ? (
                <StartLab endDate={`${instancelist.end_date}`} endTime={`${instancelist.stop_time}`} startDate={`${instancelist.start_date}`} dependson={`${instancelist.depends_on}`} labType={"custom"}/>
              ) : instancelist.status === "Running" ? (
                <React.Fragment>
                  <ReportEX pccreportdataset={pccreportdataset} />
                  <StopLab endDate={`${instancelist.end_date}`} endTime={`${instancelist.stop_time}`} startDate={`${instancelist.start_date}`} startTime={`${instancelist.start_time}`}  depends_on={`${instancelist.depends_on}`} labType={"custom"}/>
                </React.Fragment>
              ) : instancelist.status === "Stop Initiated" ? (
                <Tooltip title="Stop Initiated" arrow>
                  <span style={{ display: 'inline-flex' }}>
                    <Button
                      sx={{
                        mx: 1,
                        width: { xs: '140px', sm: '150px' },
                        height: '30px',
                        marginBottom: "20px",
                        marginRight: "30px",
                        marginTop: "-15px",
                        borderRadius: '50px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                      }}
                      style={{ whiteSpace: 'nowrap' }}
                      variant="outlined"
                      color="primary"
                      startIcon={<StopTwoToneIcon />}
                      disabled={timeDiff(`${instancelist.end_date}`, `${instancelist.stop_time}`, `${instancelist.start_date}`,
                        `${instancelist.start_time}`, instancelist.depends_on, instancelist.manage_labs)}
                    >
                      Stop Initiated
                    </Button>
                  </span>
                </Tooltip>
              ) : instancelist.status === "Start Initiated" ? (
                <Tooltip title="Start Initiated" arrow>
                  <span style={{ display: 'inline-flex' }}>
                    <Button
                      sx={{
                        mx: 1,
                        width: { xs: '26px', sm: '30px' },
                        height: { xs: '26px', sm: '30px' },
                        minWidth: 'auto',
                        marginRight: '30px',
                        marginBottom: '20px',
                        marginTop: '-15px',
                        borderRadius: '50px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                        p: 0,
                      }}
                      style={{ whiteSpace: 'nowrap' }}
                      variant="outlined"
                      color="primary"
                      disabled={timeDiff(`${instancelist.end_date}`, `${instancelist.stop_time}`, `${instancelist.start_date}`,
                        `${instancelist.start_time}`, instancelist.depends_on, instancelist.manage_labs)}
                      aria-label="Start Initiated"
                    >
                      <PlayArrowTwoToneIcon sx={{ fontSize: { xs: '1rem', sm: '1.1rem' } }} />
                    </Button>
                  </span>
                </Tooltip>
              ) : instancelist.status === "Stopping" ? (
                <Tooltip title="stopping" arrow>
                  <span style={{ display: 'inline-flex' }}>
                    <IconButton
                      sx={{
                        mx: 1,
                        width: { xs: '26px', sm: '30px' },
                        height: { xs: '26px', sm: '30px' },
                        minWidth: 'auto',
                        marginRight: '30px',
                        marginBottom: '20px',
                        marginTop: '-15px',
                        borderRadius: '50px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                        p: 0,
                      }}
                      color="primary"
                      disabled={timeDiff(`${instancelist.end_date}`, `${instancelist.stop_time}`, `${instancelist.start_date}`,
                        `${instancelist.start_time}`, instancelist.depends_on, instancelist.manage_labs)}
                      aria-label="stopping"
                    >
                      <StopTwoToneIcon sx={{ fontSize: { xs: '1rem', sm: '1.1rem' } }} />
                    </IconButton>
                  </span>
                </Tooltip>
              ) : instancelist.status === "Starting" ? (
                <Tooltip title="Starting" arrow>
                  <span style={{ display: 'inline-flex' }}>
                    <Button
                      sx={{
                        mx: 1,
                        width: { xs: '26px', sm: '30px' },
                        height: { xs: '26px', sm: '30px' },
                        minWidth: 'auto',
                        marginRight: '30px',
                        marginBottom: '20px',
                        marginTop: '-15px',
                        borderRadius: '50px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                        p: 0,
                      }}
                      style={{ whiteSpace: 'nowrap' }}
                      variant="outlined"
                      color="primary"
                      disabled={timeDiff(`${instancelist.end_date}`, `${instancelist.stop_time}`, `${instancelist.start_date}`,
                        `${instancelist.start_time}`, instancelist.depends_on, instancelist.manage_labs)}
                      aria-label="Starting"
                    >
                      <PlayArrowTwoToneIcon sx={{ fontSize: { xs: '1rem', sm: '1.1rem' } }} />
                    </Button>
                  </span>
                </Tooltip>
              ) : (
                ""
              )}
            <Tooltip title="Delete" arrow>
              <span>
                <Button
                  sx={{
                    mx: 0.5,
                    height: { xs: "26px", sm: "30px" },
                    width: { xs: "26px", sm: "30px" },
                    minWidth: "auto",
                    marginRight: "30px",
                    marginBottom: "20px",
                    marginTop: "-15px",
                    borderRadius: "50px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                    p: 0,
                  }}
                  variant="contained"
                  color="secondary"
                  onClick={handleClickOpenDelete}
                  disabled={
                    !(
                      instancelist.status === "Running" ||
                      instancelist.status === "Stopped" ||
                      instancelist.status === "failed_con_update"
                    ) ||
                    timeDiff(`${instancelist.end_date}`, `${instancelist.stop_time}`, `${instancelist.start_date}`,
                      `${instancelist.start_time}`, instancelist.depends_on, instancelist.manage_labs)
                  }
                  aria-label="delete"
                >
                  <DeleteIcon sx={{ fontSize: { xs: "1rem", sm: "1.1rem" } }} />
                </Button>
              </span>
            </Tooltip>
            </Box>
            <Container maxWidth={false}>
              <Box border={0} sx={{ mt: 0 }}>
                <Card>
                  <CardContent>
                    <Box
                      sx={{
                        background: 'linear-gradient(90deg, rgb(6, 57, 108), rgb(6, 57, 108))',
                        borderRadius: '8px',
                        px: 2,
                        py: 0.75, // ↓ reduced vertical padding for smaller height
                        mb: 2,
                        boxShadow: 2,
                      }}
                    >
                      <Typography
                        color="white"
                        display="inline-block"
                        gutterBottom
                        variant="h6"
                        sx={{
                          lineHeight: 1.1,
                          fontWeight: 500, // reduced from 'bold' (700) → medium weight
                        }}
                        
                      >
                        Lab Name: {instancelist.name}
                      </Typography>
                    </Box>
                    <div>
                      <TableContainer component={Paper}>
                        <Table size="small" aria-label="simple table">
                          <TableBody>
                            <TableRow key="name">
                              <TableCell
                                align="left"
                                component="th"
                                scope="row"
                              >
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block" }}
                                  gutterBottom
                                >
                                  CodeShare : <Tooltip title="Open CodeShare" arrow>
                                    <Button
                                      size="small"
                                      sx={{
                                        height: "25px",
                                        borderRadius: '50px',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                        px: 2,
                                      }}
                                      variant="outlined"
                                      target="_blank"
                                      endIcon={<OpenInNewIcon style={{ height: "15px" }} />}
                                      href={instancelist.codeshare}
                                    >
                                      Open
                                    </Button>
                                  </Tooltip>
                                  <CopyToClipboard
                                    text={instancelist.codeshare}
                                    onCopy={() => setCopied(true)}
                                  >
                                    <IconButton
                                      aria-label="Filter"
                                      color="primary"
                                      onClick={handleClick}
                                      style={{ height: "25px" }}
                                    >
                                      <FileCopyOutlinedIcon style={{ height: "20px" }} />
                                    </IconButton>
                                  </CopyToClipboard>
                                  <Popover
                                    id={id}
                                    open={open1}
                                    anchorEl={anchorEl}
                                    onClose={handleClose}
                                    anchorOrigin={{
                                      vertical: "bottom",
                                      horizontal: "center",
                                    }}
                                    transformOrigin={{
                                      vertical: "top",
                                      horizontal: "center",
                                    }}
                                  >
                                    <Typography
                                      style={{
                                        color: "forestgreen",
                                      }}
                                    >
                                      Copied!.
                                    </Typography>
                                  </Popover>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{
                                    display: "inline-block",
                                  }}
                                  gutterBottom
                                >
                                  Status : <span style={{ fontWeight: "normal" }}>{instancelist.status}</span>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block" }}
                                  gutterBottom
                                >
                                  Number of Trainees : <span style={{ fontWeight: "normal" }}>{instancelist.no_of_trainee}</span>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block" }}
                                  gutterBottom
                                >Budget : <span style={{ fontWeight: "normal" }}>{`${instancelist.budget}`}</span> </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block" }}
                                  gutterBottom
                                >Spent : <span style={{ fontWeight: "normal" }}>{`${instancelist.spent}`}</span> </Typography>
                              </TableCell>
                            </TableRow>
                            <TableRow key="name">
                              <TableCell
                                align="left"
                                component="th"
                                scope="row"
                              >
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block" }}
                                  gutterBottom
                                >
                                  Schedule : <span style={{ fontWeight: "normal" }}>{instancelist.depends_on}</span>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block" }}
                                  gutterBottom
                                >
                                  Start Date : <span style={{ fontWeight: "normal" }}>{DateTime1(`${instancelist.start_date}`)}</span>
                                </Typography>
                              </TableCell>
                              {instancelist.start_time === "" ||
                                instancelist.start_time === null ? (
                                <TableCell align="left">
                                  <Typography
                                    variant="h6"
                                    fontWeight="fontWeightBold"
                                    style={{ display: "inline-block" }}
                                    gutterBottom
                                  >
                                    Start Time : <span style={{ fontWeight: "normal" }}>NA</span>
                                  </Typography>
                                </TableCell>
                              ) : (
                                <TableCell align="left">
                                  <Typography
                                    variant="h6"
                                    fontWeight="fontWeightBold"
                                    style={{ display: "inline-block" }}
                                    gutterBottom
                                  >
                                    Start Time : <span style={{ fontWeight: "normal" }}>{DateTime3(`${instancelist.start_date}`, `${instancelist.start_time}`)}</span>
                                  </Typography>
                                </TableCell>
                              )}
                              <TableCell align="left">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block" }}
                                  gutterBottom
                                >
                                  End Date : <span style={{ fontWeight: "normal" }}>{DateTime2(`${instancelist.end_date}`, `${instancelist.stop_time}`)}</span>
                                </Typography>
                              </TableCell>

                              {instancelist.stop_time === "" ||
                                instancelist.stop_time === null ? (
                                <TableCell align="left">
                                  <Typography
                                    variant="h6"
                                    fontWeight="fontWeightBold"
                                    style={{ display: "inline-block" }}
                                    gutterBottom
                                  >
                                    Stop Time : <span style={{ fontWeight: "normal" }}>NA</span>
                                  </Typography>
                                </TableCell>
                              ) : (
                                <TableCell align="left">
                                  <Typography
                                    variant="h6"
                                    fontWeight="fontWeightBold"
                                    style={{ display: "inline-block" }}
                                    gutterBottom
                                  >
                                    End Time : <span style={{ fontWeight: "normal" }}>{DateTime4(`${instancelist.end_date}`, `${instancelist.stop_time}`)}</span>
                                  </Typography>
                                </TableCell>
                              )}
                            </TableRow>
                            <TableRow key="meetingurl">
                              <TableCell align="left" component="th" scope="row">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block" }}
                                  gutterBottom
                                >
                                  Meeting Link:
                                  <a
                                    href={ensureAbsoluteUrl(instancelist.meeting_url)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ textDecoration: 'underline', color: 'blue', marginLeft: '10px' }}
                                  >
                                    {instancelist.meeting_url}
                                  </a>
                                  <CopyToClipboard
                                    text={instancelist.meeting_url}
                                    onCopy={() => setCopied(true)}
                                  >
                                    <IconButton
                                      aria-label="Filter"
                                      color="primary"
                                      onClick={handleClick}
                                      style={{ height: "25px" }}
                                    >
                                      <FileCopyOutlinedIcon style={{ height: "20px" }} />
                                    </IconButton>
                                  </CopyToClipboard>
                                  <Popover
                                    id={id}
                                    open={open1}
                                    anchorEl={anchorEl}
                                    onClose={handleClose}
                                    anchorOrigin={{
                                      vertical: "bottom",
                                      horizontal: "center",
                                    }}
                                    transformOrigin={{
                                      vertical: "top",
                                      horizontal: "center",
                                    }}
                                  >
                                    <Typography style={{ color: "forestgreen" }}>
                                      Copied!.
                                    </Typography>
                                  </Popover>
                                </Typography>
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </CardContent>
                </Card>
              </Box>
              <Divider />
              <Box border={0} sx={{ mt: 1 }} paddingBottom={0} paddingTop={0}>
                <Card>
                  <Typography
                    color="textPrimary"
                    variant="h6"
                    gutterBottom
                    style={{ marginLeft: "20px", marginTop: '10px' }}
                  >
                    Instance Details
                    <Divider />
                  </Typography>
                  <TextField
                    fullWidth
                    name={`trainee_name`}
                    id={`trainee_name`}
                    onChange={handleChange}
                    required
                    select
                    SelectProps={{
                      native: true,
                      style: {
                        color: '#000000',
                        height: '30px'
                      },
                    }}
                    autoComplete="name"
                    value={value}
                    sx={{ width: '400px' }}
                    style={{ color: '#ffffff', marginLeft: '20px', marginTop: '10px' }}
                  >
                    <option value="" style={{ color: '#000000' }}>Select the Trainee</option>
                    {instancelist.Instance_info.map((instance_info, i) => (
                      <option key={i} value={i} {...a11yProps(i)} style={{ color: '#000000' }}>
                        {instance_info.name}
                      </option>
                    ))}
                  </TextField>
                  <PerfectScrollbar>
                    <Card>
                      <CardContent>
                        {instancelist.Instance_info.map((instance_info, i) => {
                          return (
                            <React.Fragment key={instance_info.name || i}>
                              <TabPanel value={value} index={i}>
                                <Grid
                                  container
                                  spacing={1}
                                  sx={{ mt: -5, mb: -0.5, ml: 0 }}
                                >
                                  <Grid item xs={12} sx={{ ml: 0 }}>
                                    <Typography
                                      style={{ display: "inline-block" }}
                                      gutterBottom
                                    >
                                      Assigned user :
                                    </Typography>
                                    <Typography
                                      fontWeight={500}
                                      sx={{ ml: 1 }}
                                      style={{ display: "inline-block" }}
                                      gutterBottom
                                    >
                                      {instance_info.email}
                                    </Typography>
                                  </Grid>

                                </Grid>
                                <TableContainer component={Paper}>
                                  <Table
                                    size="small"
                                    aria-label="a dense table"
                                  >
                                    <TableHead
                                      style={{ backgroundColor: "#06396c", }}
                                    >
                                      <TableRow sx={{ height: '30px' }}>
                                        <TableCell />
                                        <TableCell
                                          style={{ color: "#ffffff" }}
                                          align="left"
                                        >
                                          Name
                                        </TableCell>
                                        <TableCell
                                          style={{ color: "#ffffff" }}
                                          align="left"
                                        >
                                          Status
                                        </TableCell>
                                        <TableCell
                                          style={{ color: "#ffffff", paddingRight: '10px' }}
                                          align="left"
                                        >
                                          Console Panel
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {instance_info.details.map((details) => (
                                        <React.Fragment key={details.name}>
                                          <TableRow>
                                            <TableCell>
                                              <IconButton
                                                size="small"
                                                onClick={() => handleExpandRow(details.name)}
                                              >
                                                {expandedRow === details.name ? (
                                                  <KeyboardArrowUp />
                                                ) : (
                                                  <KeyboardArrowDown />
                                                )}
                                              </IconButton>
                                            </TableCell>
                                            <TableCell style={{ paddingLeft: '10px' }} align="left">{details.name}</TableCell>
                                            <TableCell style={{ paddingLeft: '5px' }} align="left">
                                              {details.status === "Creating" ? (
                                                <Typography
                                                variant="h6"
                                                sx={{ ml: 2 }}
                                                fontWeight="fontWeightBold"
                                                style={{
                                                  display: "inline-block",
                                                  color: "#2234E8",
                                                }}
                                                gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status ===
                                                "Running" ||
                                                details.status === "running" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#209508",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Stopped" || details.status === "stopped" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#F3AF05",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Starting" || details.status === "starting" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#F3AF05",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Stopping" || details.status === "stopping" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#F3AF05",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Start Initiated" || details.status === "start initiated" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#F3AF05",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Stop Initiated" || details.status === "stop initiated" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#F3AF05",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Cordoned" || details.status === "cordoned" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#848884",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Failed_Create" || details.status === "failed_create" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Failed_Con_Create" || details.status === "failed_con_create" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Failed_Stop" || details.status === "failed_stop" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Failed_Start" || details.status === "failed_start" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Failed_Con_Update" || details.status === "failed_con_update" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Failed_Cordon" || details.status === "failed_cordon" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "failed_add" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "failed_remove" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "failed_add_con_create" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : (
                                                "NA"
                                              )}
                                            </TableCell>
                                            <TableCell align="left" colSpan={3}>
                                              <Tooltip title="Connect" arrow>
                                                <span>
                                                  <Button
                                                    size="small"
                                                    variant="contained"
                                                    target="_blank"
                                                    endIcon={<OpenInNewIcon style={{ height: "15px" }} />}
                                                    href={details.connection_url}
                                                    sx={{
                                                      height: "25px",
                                                      borderRadius: '50px',
                                                      boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                                      px: 2,
                                                    }}
                                                    disabled={details.status !== "running" && details.status !== "Running"}
                                                  >
                                                    Connect
                                                  </Button>
                                                </span>
                                              </Tooltip>
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell
                                              style={{ paddingBottom: 0, paddingTop: 0 }}
                                              colSpan={4}
                                            >
                                              <Collapse
                                                in={expandedRow === details.name}
                                                timeout="auto"
                                                unmountOnExit
                                              >
                                                <div>
                                                  {/* Content to display when row is expanded */}
                                                  <TableRow>
                                                    <TableCell align="left" component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '20px' }}>
                                                      <strong>Instance Public IP: </strong>
                                                    </TableCell>
                                                    <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                                                      {details.public_ip_address ? (
                                                        <>
                                                          {details.public_ip_address}
                                                          <CopyToClipboard
                                                            text={details.public_ip_address}
                                                            onCopy={() => setCopied(true)}
                                                          >
                                                            <IconButton
                                                              aria-label="Filter"
                                                              color="primary"
                                                              onClick={handleClick}
                                                            >
                                                              <FileCopyOutlinedIcon style={{ height: "20px" }} />
                                                            </IconButton>
                                                          </CopyToClipboard>
                                                          <Popover
                                                            id={id}
                                                            open={open1}
                                                            anchorEl={anchorEl}
                                                            onClose={handleClose}
                                                            anchorOrigin={{
                                                              vertical: "bottom",
                                                              horizontal: "center",
                                                            }}
                                                            transformOrigin={{
                                                              vertical: "top",
                                                              horizontal: "center",
                                                            }}
                                                          >
                                                            <Typography style={{ color: "forestgreen" }}>
                                                              Copied!.
                                                            </Typography>
                                                          </Popover>
                                                        </>
                                                      ) : (
                                                        "NA"
                                                      )}
                                                    </TableCell>
                                                    <TableCell component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '110px' }}>
                                                      <strong>Instance Username: </strong>
                                                    </TableCell>
                                                    <TableCell
                                                      align="left"
                                                      component="th"
                                                      scope="row"
                                                      style={{ whiteSpace: 'nowrap' }}
                                                    >
                                                      <Typography
                                                        variant="h6"
                                                        fontWeight="fontWeightBold"
                                                        style={{ display: "inline-block" }}
                                                        gutterBottom
                                                      >
                                                        {details.instance_username}
                                                      </Typography>
                                                      <CopyToClipboard
                                                        text={details.instance_username}
                                                        onCopy={() => setCopied(true)}
                                                      >
                                                        <IconButton
                                                          aria-label="Filter"
                                                          color="primary"
                                                          onClick={handleClick}

                                                        >
                                                          <FileCopyOutlinedIcon style={{ height: "20px" }} />
                                                        </IconButton>
                                                      </CopyToClipboard>
                                                      <Popover
                                                        id={id}
                                                        open={open1}
                                                        anchorEl={anchorEl}
                                                        onClose={handleClose}
                                                        anchorOrigin={{
                                                          vertical: "bottom",
                                                          horizontal: "center",
                                                        }}
                                                        transformOrigin={{
                                                          vertical: "top",
                                                          horizontal: "center",
                                                        }}
                                                      >
                                                        <Typography style={{ color: "forestgreen" }}>
                                                          Copied!.
                                                        </Typography>
                                                      </Popover>
                                                    </TableCell>
                                                    <TableCell align="left" component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '110px' }}>
                                                      <strong>Instance Password: </strong>
                                                    </TableCell>
                                                    <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                                                      {showInstancePassword ? (
                                                        <Typography
                                                          variant="h6"
                                                          fontWeight="fontWeightBold"
                                                          style={{ display: "inline-block" }}
                                                          gutterBottom
                                                        >
                                                          {details.instance_password}
                                                        </Typography>
                                                      ) : (
                                                        <Typography
                                                          variant="h6"
                                                          fontWeight="fontWeightBold"
                                                          style={{ display: "inline-block", marginLeft: "-10px" }}
                                                          gutterBottom
                                                        >
                                                          {"******"}
                                                        </Typography>
                                                      )}
                                                      <Tooltip title={showInstancePassword ? "Hide Password" : "Show Password"} arrow>
                                                        <IconButton
                                                          aria-label="Toggle Password Visibility"
                                                          color="primary"
                                                          onClick={handleInstancePasswordIconClick}
                                                        >
                                                          {showInstancePassword ? (
                                                            <VisibilityOffIcon style={{ marginLeft: "10px", fontSize: "20px" }} />
                                                          ) : (
                                                            <VisibilityIcon style={{ marginLeft: "10px", fontSize: "20px" }} />
                                                          )}
                                                        </IconButton>
                                                      </Tooltip>
                                                      <CopyToClipboard
                                                        text={details.instance_password}
                                                        onCopy={() => setCopied(true)}
                                                      >
                                                        <IconButton
                                                          aria-label="Copy"
                                                          color="primary"
                                                          onClick={handleClick}
                                                        >
                                                          <FileCopyOutlinedIcon style={{ height: "20px" }} />
                                                        </IconButton>
                                                      </CopyToClipboard>
                                                      <Popover
                                                        id={id}
                                                        open={open1}
                                                        anchorEl={anchorEl}
                                                        onClose={handleClose}
                                                        anchorOrigin={{
                                                          vertical: "bottom",
                                                          horizontal: "center",
                                                        }}
                                                        transformOrigin={{
                                                          vertical: "top",
                                                          horizontal: "center",
                                                        }}
                                                      >
                                                        <Typography style={{ color: "forestgreen" }}>
                                                          Copied!.
                                                        </Typography>
                                                      </Popover>
                                                    </TableCell>
                                                  </TableRow>
                                                  <TableRow>
                                                    <TableCell align="left" component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '20px' }}>
                                                      <strong>Instance Private IP: </strong>
                                                    </TableCell>
                                                    <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                                                      {details.private_ip_address ? (
                                                        <>
                                                          {details.private_ip_address}
                                                          <CopyToClipboard
                                                            text={details.private_ip_address}
                                                            onCopy={() => setCopied(true)}
                                                          >
                                                            <IconButton
                                                              aria-label="Filter"
                                                              color="primary"
                                                              onClick={handleClick}
                                                            >
                                                              <FileCopyOutlinedIcon style={{ height: "20px" }} />
                                                            </IconButton>
                                                          </CopyToClipboard>
                                                          <Popover
                                                            id={id}
                                                            open={open1}
                                                            anchorEl={anchorEl}
                                                            onClose={handleClose}
                                                            anchorOrigin={{
                                                              vertical: "bottom",
                                                              horizontal: "center",
                                                            }}
                                                            transformOrigin={{
                                                              vertical: "top",
                                                              horizontal: "center",
                                                            }}
                                                          >
                                                            <Typography style={{ color: "forestgreen" }}>
                                                              Copied!.
                                                            </Typography>
                                                          </Popover>
                                                        </>
                                                      ) : (
                                                        "NA"
                                                      )}
                                                    </TableCell>
                                                    <TableCell align="left" component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '110px' }}>
                                                      <strong>OS Type: </strong>
                                                    </TableCell>
                                                    <TableCell style={{ whiteSpace: 'nowrap' }} align="center">{details.ostype}</TableCell>
                                                    <TableCell component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '110px' }}>
                                                      <strong>OS Version: </strong>
                                                    </TableCell>
                                                    <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                                                      {details.ostype === 'windows'
                                                        ? details.windows_type
                                                        : details.linux_type}
                                                    </TableCell>
                                                  </TableRow>
                                                  <TableRow>
                                                    <TableCell align="left" component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '20px' }}>
                                                      <strong>Open Ports: </strong>
                                                    </TableCell>
                                                    <TableCell style={{ whiteSpace: 'nowrap' }} align="center">{details.port}</TableCell>
                                                    <TableCell component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '110px' }}>
                                                      <strong>Storage: </strong>
                                                    </TableCell>
                                                    <TableCell style={{ whiteSpace: 'nowrap' }} align="center">{details.instance_storage}</TableCell>
                                                    <TableCell align="left" component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '110px' }}>
                                                      <strong>Instance Type: </strong>
                                                    </TableCell>
                                                    <TableCell style={{ whiteSpace: 'nowrap' }} align="center">{details.instance_type}</TableCell>
                                                  </TableRow>
                                                  <TableRow>
                                                    <TableCell align="left" component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '20px' }}>
                                                      <strong>Instance CPU: </strong>
                                                    </TableCell>
                                                    <TableCell style={{ whiteSpace: 'nowrap' }} align="center">{details.instance_type === 'nano' ? '1 vCPUs' :
                                                      details.instance_type === 'micro' ? '1 vCPUs' :
                                                        details.instance_type === 'small' ? '2 vCPUs' :
                                                          details.instance_type === 'medium' ? '2 vCPUs' :
                                                            details.instance_type === 'large' ? '2 vCPUs' :
                                                              details.instance_type === 'xlarge' ? '4 vCPUs' :
                                                                details.instance_type === '2xlarge' ? '8 vCPUs' : 'NA'}
                                                    </TableCell>
                                                    <TableCell component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '110px' }}>
                                                      <strong>Instance Memory: </strong>
                                                    </TableCell>
                                                    <TableCell style={{ whiteSpace: 'nowrap' }} align="center">{details.instance_type === 'nano' ? '1 GiB' :
                                                      details.instance_type === 'micro' ? '2 GiB' :
                                                        details.instance_type === 'small' ? '2 GiB' :
                                                          details.instance_type === 'medium' ? '4 GiB' :
                                                            details.instance_type === 'large' ? '8 GiB' :
                                                              details.instance_type === 'xlarge' ? '16 GiB' :
                                                                details.instance_type === '2xlarge' ? '32 GiB' : 'NA'}
                                                    </TableCell>
                                                    <TableCell align="left" component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '110px' }}>
                                                      <strong>Usage Report: </strong>
                                                    </TableCell>
                                                    <TableCell
                                                      style={{ whiteSpace: 'nowrap' }}
                                                      align="center">
                                                      <ActiveLog
                                                        name={details.name}
                                                        index_name={details.tag}
                                                        analytics_panel_id={details.analytics_panel_id}
                                                      />
                                                    </TableCell>
                                                  </TableRow>
                                                  <TableRow>
                                                    <TableCell align="left" component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '20px' }}>
                                                      <strong>Application: </strong>
                                                    </TableCell>
                                                    {details.apps === "notapply" ? (
                                                      <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                                                        NA
                                                      </TableCell>
                                                    ) : (
                                                      <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                                                        {details.apps.map((number) => (
                                                          <li>{number}</li>
                                                        ))}
                                                      </TableCell>
                                                    )}
                                                    <TableCell component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '110px' }}>
                                                      <strong>Tools: </strong>
                                                    </TableCell>
                                                    {details.tools === "notapply" ? (
                                                      <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                                                        NA
                                                      </TableCell>
                                                    ) : (
                                                      <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                                                        <li>{details.tools}</li>
                                                      </TableCell>
                                                    )}
                                                    <TableCell align="left" component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '110px' }}>
                                                      <strong>Language: </strong>
                                                    </TableCell>
                                                    {details.programming ===
                                                      "notapply" ? (
                                                      <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                                                        NA
                                                      </TableCell>
                                                    ) : (
                                                      <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                                                        {details.programming.map(
                                                          (number) => (
                                                            <li>{number}</li>
                                                          )
                                                        )}
                                                      </TableCell>
                                                    )}
                                                  </TableRow>
                                                  <TableRow>
                                                    <TableCell align="left" component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '20px' }}>
                                                      <strong>System Tool: </strong>
                                                    </TableCell>
                                                    {details.system_tools ===
                                                      "notapply" ? (
                                                      <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                                                        NA
                                                      </TableCell>
                                                    ) : (
                                                      <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                                                        {details.system_tools.map(
                                                          (number) => (
                                                            <li>{number}</li>
                                                          )
                                                        )}
                                                      </TableCell>
                                                    )}
                                                    <TableCell align="left" component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '110px' }}>
                                                      <strong>Manage Instance: </strong>
                                                    </TableCell>
                                                    <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                                                      {details.status === "stopped" ? (
                                                        <IndividualStartLab tag={details.tag} endDate={`${instancelist.end_date}`} endTime={`${instancelist.stop_time}`} startDate={`${instancelist.start_date}`}
                                                          startTime={`${instancelist.start_time}`} depends_on={instancelist.depends_on} manage_labs={instancelist.manage_labs} startcron={instancelist.startcron_expression} startcron1={instancelist.startcron_expression2} repeat_frequency={instancelist.repeat_frequency} on_days={`${instancelist.on_days}`} labType={"custom"}/>
                                                      ) : details.status === "running" ? (
                                                        <IndividualStopLab tag={details.tag} endDate={`${instancelist.end_date}`} endTime={`${instancelist.stop_time}`} startDate={`${instancelist.start_date}`}
                                                          startTime={`${instancelist.start_time}`} depends_on={instancelist.depends_on} manage_labs={instancelist.manage_labs} labType={"custom"}/>
                                                      ) : details.status === "stopping" ? (
                                                        <Tooltip title="stopping" arrow>
                                                          <span style={{ display: 'inline-flex' }}>
                                                            <IconButton
                                                              sx={{
                                                                width: { xs: '26px', sm: '30px' },
                                                                height: { xs: '26px', sm: '30px' },
                                                                minWidth: 'auto',
                                                                borderRadius: '8px',
                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                                                p: 0,
                                                              }}
                                                              color="primary"
                                                              disabled={timeDiff(`${instancelist.end_date}`, `${instancelist.stop_time}`, `${instancelist.start_date}`,
                                                                `${instancelist.start_time}`, instancelist.depends_on, instancelist.manage_labs)}
                                                              aria-label="stopping"
                                                            >
                                                              <StopTwoToneIcon sx={{ fontSize: { xs: '1rem', sm: '1.1rem' } }} />
                                                            </IconButton>
                                                          </span>
                                                        </Tooltip>
                                                      ) : details.status === "starting" ? (
                                                        <Tooltip title="Starting" arrow>
                                                          <span style={{ display: 'inline-flex' }}>
                                                            <Button
                                                              sx={{
                                                                width: { xs: '110px', sm: '120px' },
                                                                height: '28px',
                                                                borderRadius: '50px',
                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                                                fontSize: '0.75rem',
                                                                px: 2,
                                                              }}
                                                              variant="outlined"
                                                              color="primary"
                                                              startIcon={<PlayArrowTwoToneIcon />}
                                                              disabled={timeDiff(`${instancelist.end_date}`, `${instancelist.stop_time}`, `${instancelist.start_date}`,
                                                                `${instancelist.start_time}`, instancelist.depends_on, instancelist.manage_labs)}
                                                            >
                                                              Starting
                                                            </Button>
                                                          </span>
                                                        </Tooltip>
                                                      ) : details.status === "stop initiated" ? (
                                                        <Tooltip title="Stop Initiated" arrow>
                                                          <span style={{ display: 'inline-flex' }}>
                                                            <Button
                                                              sx={{
                                                                width: { xs: '26px', sm: '30px' },
                                                                height: { xs: '26px', sm: '30px' },
                                                                minWidth: 'auto',
                                                                borderRadius: '50px',
                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                                                p: 0,
                                                              }}
                                                              variant="outlined"
                                                              color="primary"
                                                              disabled={timeDiff(`${instancelist.end_date}`, `${instancelist.stop_time}`, `${instancelist.start_date}`,
                                                                `${instancelist.start_time}`, instancelist.depends_on, instancelist.manage_labs)}
                                                              aria-label="Stop Initiated"
                                                            >
                                                              <StopTwoToneIcon sx={{ fontSize: { xs: '1rem', sm: '1.1rem' } }} />
                                                            </Button>
                                                          </span>
                                                        </Tooltip>
                                                      ) : details.status === "start initiated" ? (
                                                        <Tooltip title="Start Initiated" arrow>
                                                          <span style={{ display: 'inline-flex' }}>
                                                            <Button
                                                              sx={{
                                                                width: { xs: '130px', sm: '140px' },
                                                                height: '28px',
                                                                borderRadius: '50px',
                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                                                fontSize: '0.75rem',
                                                                px: 2,
                                                              }}
                                                              variant="outlined"
                                                              color="primary"
                                                              startIcon={<PlayArrowTwoToneIcon />}
                                                              disabled={timeDiff(`${instancelist.end_date}`, `${instancelist.stop_time}`, `${instancelist.start_date}`,
                                                                `${instancelist.start_time}`, instancelist.depends_on, instancelist.manage_labs)}
                                                            >
                                                              Start Initiated
                                                            </Button>
                                                          </span>
                                                        </Tooltip>
                                                      ) : null}
                                                    </TableCell>
                                                    <TableCell align="left" component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '110px' }}>
                                                      <strong>Activity Log:</strong>
                                                    </TableCell>
                                                    <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                                                      <Log LabID={instancelist.id} InstanceID={details.name} />
                                                    </TableCell>
                                                  </TableRow>
                                                  {details.app_credential && details.app_credential.length > 0 ? (
                                                    details.app_credential.map((cred, index) => (
                                                      <TableRow key={index}>
                                                        <TableCell align="left" component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '20px' }}>
                                                          <strong>{cred.app || 'NA'}</strong>
                                                        </TableCell>
                                                        <TableCell style={{ whiteSpace: 'nowrap' }} align="left">
                                                          <strong></strong> {cred.url || 'NA' }
                                                          <CopyToClipboard
                                                            text={cred.url}
                                                            onCopy={() => setCopied(true)}
                                                          >
                                                            <IconButton aria-label="Copy" color="primary" onClick={handleClick}>
                                                              <FileCopyOutlinedIcon style={{ height: "20px" }} />
                                                            </IconButton>
                                                          </CopyToClipboard>
                                                          <Popover
                                                            id={id}
                                                            open={open1}
                                                            anchorEl={anchorEl}
                                                            onClose={handleClose}
                                                            anchorOrigin={{
                                                              vertical: "bottom",
                                                              horizontal: "center",
                                                            }}
                                                            transformOrigin={{
                                                              vertical: "top",
                                                              horizontal: "center",
                                                            }}
                                                          >
                                                            <Typography style={{ color: "forestgreen" }}>Copied!</Typography>
                                                          </Popover>
                                                        </TableCell>
                                                        <TableCell component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '110px' }}>
                                                          <strong>Username :</strong>
                                                        </TableCell>
                                                        <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                                                          {cred.username ? cred.username : 'NA'}
                                                          <CopyToClipboard text={cred.username} onCopy={() => setCopied(true)}>
                                                            <IconButton aria-label="Filter" color="primary" onClick={handleClick}>
                                                              <FileCopyOutlinedIcon style={{ height: "20px" }} />
                                                            </IconButton>
                                                          </CopyToClipboard>
                                                          <Popover
                                                            id={id}
                                                            open={open1}
                                                            anchorEl={anchorEl}
                                                            onClose={handleClose}
                                                            anchorOrigin={{
                                                              vertical: "bottom",
                                                              horizontal: "center",
                                                            }}
                                                            transformOrigin={{
                                                              vertical: "top",
                                                              horizontal: "center",
                                                            }}
                                                          >
                                                            <Typography style={{ color: "forestgreen" }}>Copied!</Typography>
                                                          </Popover>
                                                        </TableCell>
                                                        <TableCell align="left" component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '110px' }}>
                                                          <strong>Password :</strong>
                                                        </TableCell>
                                                        <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                                                          {cred.password ? (
                                                            <>
                                                              {showAppPasswords ? (
                                                                <Typography variant="h6" fontWeight="fontWeightBold" style={{ display: "inline-block" }} gutterBottom>
                                                                  {cred.password}
                                                                </Typography>
                                                              ) : (
                                                                <Typography variant="h6" fontWeight="fontWeightBold" style={{ display: "inline-block", marginLeft: "-10px" }} gutterBottom>
                                                                  {"******"}
                                                                </Typography>
                                                              )}
                                                              <Tooltip title={showAppPasswords ? "Hide Password" : "Show Password"} arrow>
                                                                <IconButton
                                                                  aria-label="Toggle App Password Visibility"
                                                                  color="primary"
                                                                  onClick={handleAppPasswordIconClick}
                                                                >
                                                                  {showAppPasswords ? (
                                                                    <VisibilityOffIcon style={{ marginLeft: "10px", fontSize: "20px" }} />
                                                                  ) : (
                                                                    <VisibilityIcon style={{ marginLeft: "10px", fontSize: "20px" }} />
                                                                  )}
                                                                </IconButton>
                                                              </Tooltip>
                                                              <CopyToClipboard text={cred.password} onCopy={() => setCopied(true)}>
                                                                <IconButton aria-label="Copy" color="primary" onClick={handleClick}>
                                                                  <FileCopyOutlinedIcon style={{ height: "20px" }} />
                                                                </IconButton>
                                                              </CopyToClipboard>
                                                              <Popover
                                                                id={id}
                                                                open={open1}
                                                                anchorEl={anchorEl}
                                                                onClose={handleClose}
                                                                anchorOrigin={{
                                                                  vertical: "bottom",
                                                                  horizontal: "center",
                                                                }}
                                                                transformOrigin={{
                                                                  vertical: "top",
                                                                  horizontal: "center",
                                                                }}
                                                              >
                                                                <Typography style={{ color: "forestgreen" }}>Copied!</Typography>
                                                              </Popover>
                                                            </>
                                                          ) : 'NA'}
                                                        </TableCell>
                                                      </TableRow>
                                                    ))
                                                  ) : (
                                                    <TableRow>
                                                      <TableCell align="left" component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '20px' }}>
                                                        <strong>App:</strong>
                                                      </TableCell>
                                                      <TableCell style={{ whiteSpace: 'nowrap' }} align="center">
                                                        <strong>URL:</strong> NA
                                                      </TableCell>
                                                      <TableCell component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '110px' }}>
                                                        <strong>Username :</strong>
                                                      </TableCell>
                                                      <TableCell style={{ whiteSpace: 'nowrap' }} align="center">NA</TableCell>
                                                      <TableCell align="left" component="th" scope="row" style={{ color: "#06396c", whiteSpace: 'nowrap', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '110px' }}>
                                                        <strong>Password :</strong>
                                                      </TableCell>
                                                      <TableCell style={{ whiteSpace: 'nowrap' }} align="center">NA</TableCell>
                                                    </TableRow>
                                                  )}
                                                </div>
                                              </Collapse>
                                            </TableCell>
                                          </TableRow>
                                        </React.Fragment>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </TabPanel>
                            </React.Fragment>
                          );
                        })}
                      </CardContent>
                    </Card>
                  </PerfectScrollbar>
                </Card>
              </Box>
            </Container>
          </Box>
        </React.Fragment>
      ))}
    </>
  );
};

export default Detail;
